console.log('custom.js is working')

// Change slide function
function changeSlide(n, element) {
    const slides = element.closest('.slideshow-container').querySelectorAll('.mySlides');
    let currentIndex = Array.from(slides).findIndex(slide => slide.classList.contains('active'));

    // Calculate new index
    currentIndex = (currentIndex + n + slides.length) % slides.length;

    // Update active slide
    slides.forEach(slide => slide.classList.remove('active'));
    slides[currentIndex].classList.add('active');
}

// Initialize the first slide as active
document.querySelectorAll('.package').forEach(package_div => {
    const slides = package_div.querySelectorAll('.mySlides');
    if (slides.length > 0) {
        slides[0].classList.add('active'); // Show the first slide initially
    }
});

// Trip Itinerary
const tab_buttons = document.querySelectorAll('button.tablinks')
const tabs_content = document.querySelectorAll('.tabcontent')

tab_buttons[0].classList.add('active')
tabs_content[0].style.display = 'block'
  
function tripDays(evt, tripDay) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tripDay).style.display = "block";
  evt.currentTarget.className += " active";
}

// Show and hide button for policy
const get_button = document.querySelector('#show-hide-refund-button')
const content_div = document.querySelector('.refund-content')
let is_content_show_full = false

get_button.addEventListener('click', () => {
    is_content_show_full = !is_content_show_full
    if(is_content_show_full){
       content_div.style.height = "inherit" 
       get_button.innerText = "Show Fewer Terms & Conditions"
    }
    else{
        content_div.style.height = "550px"
        get_button.innerText = "Read Full Terms & Conditions"
    }
})

// Prevent video to stop by clicking
const get_videos = document.querySelectorAll('video');

function handlePlay(event) {
    // Check if the clicked target is an anchor or within an anchor
    if (event.target.tagName === 'A' || event.target.closest('a')) {
        return; // Skip the video logic for anchor links
    }

    get_videos.forEach((single_video) => {
        if (!single_video.contains(event.target)) {
            single_video.play(); // Ensure the video keeps playing
        }
    });

    console.log('clicked');
}

document.addEventListener('click', handlePlay);
document.addEventListener('touchstart', handlePlay);